import { RouteDataInterface } from '@modules/map/interfaces/route-data.interface';

export interface TestRouteInterface {
  id: string;
  title: string;
  subtitle: string;
  text: string | null;
  cities: number;
  curves: number;
  day: number;
  minutes: number;
  km: number;
  highways: number;
  landscapes: number;
  roads: number;
  color: {
    color: string;
    opacity: null | number;
  };
  geojsonData: any;
}

export class TestRouteModel {
  public id: string;
  public title: string;
  public subtitle: string;
  public text: string | null;
  public cities: number;
  public curves: number;
  public day: number;
  public minutes: number;
  public km: number;
  public highways: number;
  public landscapes: number;
  public roads: number;

  public geojsonData: any;

  public color: string;
  public cords: { lng: number; lat: number }[] = [];
  public routesData: RouteDataInterface;
  private _center?: { lng: number; lat: number };

  constructor(data: TestRouteInterface) {
    this.id = data.id;
    this.day = data.day;
    this.title = data.title;
    this.km = data.km;
    this.minutes = data.minutes;
    this.subtitle = data.subtitle;
    this.text = data.text;
    this.cities = data.cities;
    this.curves = data.curves;
    this.highways = data.highways;
    this.landscapes = data.landscapes;
    this.roads = data.roads;
    this.color = data.color.color;
    this.geojsonData = data.geojsonData;

    if (this.geojsonData) {
      this.cords = data.geojsonData.features[0].geometry.coordinates.map((cord: any) => {
        return { lng: cord[0], lat: cord[1] };
      });
    }

    this.routesData = {
      route: this,
      color: this.color,
      cords: this.cords,
    };
  }

  get center() {
    if (this._center) {
      return this._center;
    } else if (!this.cords) {
      return { lat: 0, lng: 0 };
    }
    let lat = 0,
      lng = 0,
      cordLength = this.cords.length;
    this.cords.forEach((cord) => {
      lng += cord.lng;
      lat += cord.lat;
    });
    this._center = { lng: lng / cordLength || 0, lat: lat / cordLength || 0 };
    return this._center;
  }
}
